import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: 'common',
    fallbackLng: 'en',
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
    load: 'languageOnly',
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'em', 'strong', 'i', 'span'],
    },
    resources: {
      en,
    },
  });

export default i18n;
